import isString from 'lodash/isString'
export const ERROR_NAME = 'FetchError'

export class FetchError extends Error {
  constructor(messageOrResponse) {
    let message
    let response
    let url
    if (isString(messageOrResponse)) {
      // if input is a string, treat as error message
      message = messageOrResponse
    } else {
      // otherwise, assume it is a response object and construct message
      response = messageOrResponse
      const { status, statusText } = response
      url = response.url
      const statusStr = statusText ? `${status} - ${statusText}` : status
      message = `request failed with status "${statusStr}" on ${url}`
    }
    super(message)
    this.name = ERROR_NAME
    this.response = response
    this.url = url
  }
}

export default FetchError
